/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChoiceCreate,
  ChoiceUpdate,
  ContentEditorTestDefinitionChoiceCreateResponse,
  ContentEditorTestDefinitionChoiceIndexResponse,
  ContentEditorTestDefinitionChoiceShowResponse,
  ContentEditorTestDefinitionChoiceUpdateResponse,
} from '../models';
import {
    ChoiceCreateFromJSON,
    ChoiceCreateToJSON,
    ChoiceUpdateFromJSON,
    ChoiceUpdateToJSON,
    ContentEditorTestDefinitionChoiceCreateResponseFromJSON,
    ContentEditorTestDefinitionChoiceCreateResponseToJSON,
    ContentEditorTestDefinitionChoiceIndexResponseFromJSON,
    ContentEditorTestDefinitionChoiceIndexResponseToJSON,
    ContentEditorTestDefinitionChoiceShowResponseFromJSON,
    ContentEditorTestDefinitionChoiceShowResponseToJSON,
    ContentEditorTestDefinitionChoiceUpdateResponseFromJSON,
    ContentEditorTestDefinitionChoiceUpdateResponseToJSON,
} from '../models';

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesGetRequest {
    questionCatalogueId: number;
    questionId: number;
    questionId2: number;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdDeleteRequest {
    questionCatalogueId: number;
    questionId: number;
    id: string;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdGetRequest {
    questionCatalogueId: number;
    questionId: number;
    id: string;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdPutRequest {
    questionCatalogueId: number;
    questionId: number;
    id: string;
    body?: ChoiceUpdate;
}

export interface ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesPostRequest {
    questionCatalogueId: number;
    questionId: number;
    body?: ChoiceCreate;
}

export interface ContentEditorTestsChoicesGetRequest {
    questionId: number;
}

export interface ContentEditorTestsChoicesIdDeleteRequest {
    id: string;
}

export interface ContentEditorTestsChoicesIdGetRequest {
    id: string;
}

export interface ContentEditorTestsChoicesIdPutRequest {
    id: string;
    body?: ChoiceUpdate;
}

export interface ContentEditorTestsChoicesPostRequest {
    body?: ChoiceCreate;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdChoicesGetRequest {
    testId: number;
    questionId: number;
    questionId2: number;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdChoicesIdDeleteRequest {
    testId: number;
    questionId: number;
    id: string;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdChoicesIdGetRequest {
    testId: number;
    questionId: number;
    id: string;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdChoicesIdPutRequest {
    testId: number;
    questionId: number;
    id: string;
    body?: ChoiceUpdate;
}

export interface ContentEditorTestsTestIdQuestionsQuestionIdChoicesPostRequest {
    testId: number;
    questionId: number;
    body?: ChoiceCreate;
}

/**
 * 
 */
export class ChoiceApi extends runtime.BaseAPI {

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesGetRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentEditorTestDefinitionChoiceIndexResponse>>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesGet.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesGet.');
        }

        if (requestParameters.questionId2 === null || requestParameters.questionId2 === undefined) {
            throw new runtime.RequiredError('questionId2','Required parameter requestParameters.questionId2 was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.questionId2 !== undefined) {
            queryParameters['question_id'] = requestParameters.questionId2;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/choices`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentEditorTestDefinitionChoiceIndexResponseFromJSON));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesGet(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentEditorTestDefinitionChoiceIndexResponse>> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdDeleteRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdDelete.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/choices/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdDelete(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdGetRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionChoiceShowResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdGet.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/choices/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionChoiceShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdGet(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionChoiceShowResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdPutRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionChoiceUpdateResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdPut.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/choices/{id}`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChoiceUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionChoiceUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdPut(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionChoiceUpdateResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesPostRaw(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionChoiceCreateResponse>> {
        if (requestParameters.questionCatalogueId === null || requestParameters.questionCatalogueId === undefined) {
            throw new runtime.RequiredError('questionCatalogueId','Required parameter requestParameters.questionCatalogueId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesPost.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/question_catalogues/{question_catalogue_id}/questions/{question_id}/choices`.replace(`{${"question_catalogue_id"}}`, encodeURIComponent(String(requestParameters.questionCatalogueId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChoiceCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionChoiceCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesPost(requestParameters: ContentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionChoiceCreateResponse> {
        const response = await this.contentEditorQuestionCataloguesQuestionCatalogueIdQuestionsQuestionIdChoicesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsChoicesGetRaw(requestParameters: ContentEditorTestsChoicesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentEditorTestDefinitionChoiceIndexResponse>>> {
        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsChoicesGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.questionId !== undefined) {
            queryParameters['question_id'] = requestParameters.questionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/choices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentEditorTestDefinitionChoiceIndexResponseFromJSON));
    }

    /**
     */
    async contentEditorTestsChoicesGet(requestParameters: ContentEditorTestsChoicesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentEditorTestDefinitionChoiceIndexResponse>> {
        const response = await this.contentEditorTestsChoicesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsChoicesIdDeleteRaw(requestParameters: ContentEditorTestsChoicesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsChoicesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/choices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorTestsChoicesIdDelete(requestParameters: ContentEditorTestsChoicesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorTestsChoicesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorTestsChoicesIdGetRaw(requestParameters: ContentEditorTestsChoicesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionChoiceShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsChoicesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/choices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionChoiceShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsChoicesIdGet(requestParameters: ContentEditorTestsChoicesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionChoiceShowResponse> {
        const response = await this.contentEditorTestsChoicesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsChoicesIdPutRaw(requestParameters: ContentEditorTestsChoicesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionChoiceUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsChoicesIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/choices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChoiceUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionChoiceUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsChoicesIdPut(requestParameters: ContentEditorTestsChoicesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionChoiceUpdateResponse> {
        const response = await this.contentEditorTestsChoicesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsChoicesPostRaw(requestParameters: ContentEditorTestsChoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionChoiceCreateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/choices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChoiceCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionChoiceCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsChoicesPost(requestParameters: ContentEditorTestsChoicesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionChoiceCreateResponse> {
        const response = await this.contentEditorTestsChoicesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesGetRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentEditorTestDefinitionChoiceIndexResponse>>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesGet.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesGet.');
        }

        if (requestParameters.questionId2 === null || requestParameters.questionId2 === undefined) {
            throw new runtime.RequiredError('questionId2','Required parameter requestParameters.questionId2 was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.questionId2 !== undefined) {
            queryParameters['question_id'] = requestParameters.questionId2;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/choices`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentEditorTestDefinitionChoiceIndexResponseFromJSON));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesGet(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentEditorTestDefinitionChoiceIndexResponse>> {
        const response = await this.contentEditorTestsTestIdQuestionsQuestionIdChoicesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesIdDeleteRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesIdDelete.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/choices/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesIdDelete(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentEditorTestsTestIdQuestionsQuestionIdChoicesIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesIdGetRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionChoiceShowResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesIdGet.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/choices/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionChoiceShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesIdGet(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionChoiceShowResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsQuestionIdChoicesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesIdPutRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionChoiceUpdateResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesIdPut.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/choices/{id}`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChoiceUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionChoiceUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesIdPut(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionChoiceUpdateResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsQuestionIdChoicesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesPostRaw(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorTestDefinitionChoiceCreateResponse>> {
        if (requestParameters.testId === null || requestParameters.testId === undefined) {
            throw new runtime.RequiredError('testId','Required parameter requestParameters.testId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesPost.');
        }

        if (requestParameters.questionId === null || requestParameters.questionId === undefined) {
            throw new runtime.RequiredError('questionId','Required parameter requestParameters.questionId was null or undefined when calling contentEditorTestsTestIdQuestionsQuestionIdChoicesPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/tests/{test_id}/questions/{question_id}/choices`.replace(`{${"test_id"}}`, encodeURIComponent(String(requestParameters.testId))).replace(`{${"question_id"}}`, encodeURIComponent(String(requestParameters.questionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChoiceCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorTestDefinitionChoiceCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorTestsTestIdQuestionsQuestionIdChoicesPost(requestParameters: ContentEditorTestsTestIdQuestionsQuestionIdChoicesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorTestDefinitionChoiceCreateResponse> {
        const response = await this.contentEditorTestsTestIdQuestionsQuestionIdChoicesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
